import { render } from "./indexMonetaryCorrectionIndexesComponent.vue?vue&type=template&id=29631fba"
import script from "./indexMonetaryCorrectionIndexesComponent.vue?vue&type=script&lang=js"
export * from "./indexMonetaryCorrectionIndexesComponent.vue?vue&type=script&lang=js"

import "./indexMonetaryCorrectionIndexesComponent.vue?vue&type=style&index=0&id=29631fba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__